import { useEffect } from 'react'
import { fetchCategoriesStart } from '../../store/categories/category.action'
import { useDispatch } from 'react-redux'
import { Routes,Route } from 'react-router-dom'
import './shop.style.scss'
import CategoriesPreview from '../categories-preview/category-previe.component'
import Category from '../category/category.component'
const Shop=()=>{
    const dispatch= useDispatch();


    useEffect(()=>{
        dispatch(fetchCategoriesStart())
            
        },[])
    
    return (
        <Routes>
            <Route index element={<CategoriesPreview />}  />
            <Route path=":category" element={<Category/>}  />
        </Routes>
       
        
    )


}
export default Shop;